import { MONTHS_IN_YEAR, ONE_UNIT_CENTS_COUNT } from '@/shared/constants/common';

export const getProductPrice = (amount = 0) => {
  const price = amount / ONE_UNIT_CENTS_COUNT;
  return {
    annual: price / MONTHS_IN_YEAR,
    monthly: price,
  };
};
